import { render, staticRenderFns } from "./EditBranch.vue?vue&type=template&id=89e48c4c&scoped=true"
import script from "./EditBranch.vue?vue&type=script&lang=js"
export * from "./EditBranch.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditBranch.vue?vue&type=style&index=1&id=89e48c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e48c4c",
  null
  
)

export default component.exports